import React from 'react';
import { ContentSections } from '../components/ContentSections';
import { FaqSection, GuaranteeSection } from '../components/FaqSection';
import { FinalSections } from '../components/FinalSections';
import { Hero } from '../components/Hero';
import { PricingSection } from '../components/PricingSection';
import { ProofSections } from '../components/ProofSections';
import { EarlySocialProof, ProStories } from '../components/TrustSections';
export function MegapackLanding() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink font-body text-ivory" data-id="element-187">
      <Hero data-id="element-188" />
      <EarlySocialProof data-id="element-189" />
      <ContentSections data-id="element-190" />
      <ProStories data-id="element-191" />
      <ProofSections data-id="element-192" />
      <PricingSection data-id="element-193" />
      <GuaranteeSection data-id="element-194" />
      <FaqSection data-id="element-195" />
      <FinalSections data-id="element-196" />
    </div>;
}